export default {
  showStages: 'Pokaż sceny',
};
